var _this = this;
var subscriptionIds = "X";
var subscriptionId = "X";
var price = 0;
var productId = "";
var variantId = "";
var productTitle = "";
var selectedProductIndex = 0;
var quantity = "";
var quantityHuman = "";
var frequency = "";
var frequencyHuman = "";
var grind = "";
var grindHuman = "";
var currentStep = 1;
// var rechargeRoastersChoice = [30224,78769,79107]; // data from recharge
// var rechargeBlend = [30752,79108,79113]; // data from recharge
// var rechargeRoastersChoicePrices = [];
// var rechargeBlendPrices = [];

$(document).ready(function() {

  // hide recharge form
  // $(".recharge_data").addClass("hidden");


  $("select[name=productSelector]").on('change', function() {

    // first deselect old ones
    var old = $("[data-action=selectProduct].active");
    if (old) {
      $(old).removeClass("active");
      $(old).html("Select");
    }

    // store data
    selectedProductIndex = $("option:selected", this).index() - 1;// remember the first element is placeholder and not a real value
    var selectedOption = $('option:selected', this);
    productId = $(selectedOption).data("productid");
    variantId = $(selectedOption).data("variantid");
    productTitle = $(selectedOption).html();
    subscriptionIds = $(selectedOption).data("subscriptionids");
    // $("input[name=id]").val(variantId);
    // $("input[name=id]").attr("data-productid", variantId);

    $('.single-option-selector:eq(0)').val(productTitle)[0].dispatchEvent(new Event("change"));
    $('.single-option-selector:eq(0)').trigger("change");

    // update UI
    $(this).addClass("active");
    currentStep = 2;
    _this.onUpdate();
    _this.scrollTo($("[data-scrollid=select-quantity]"), 300);

  });

  $("[data-action=selectProduct]").click(function(ev) {
    ev.preventDefault();
    // first deselect old ones
    var old = $("[data-action=selectProduct].active");
    if (old) {
      $(old).removeClass("active");
      $(old).html("Select");
    }
    // deactivate select
    $("select[name=productSelector]").removeClass("active");
    $("select[name=productSelector]").val("none");
    // store data
    selectedProductIndex = 0;
    productId = $(this).data("productid");
    // variantId = $(this).data("variantid");
    productTitle = $(this).data("title");
    subscriptionIds = $(this).data("subscriptionids");
    // $("input[name=id]").val(variantId);
    // $("input[name=id]").attr("data-productid", variantId);
    // $("form#product-form").attr("data-productid", variantId);
    // $("form#product-form").attr("data-product-id", variantId);
    // $("input[name='properties[subscription_id]'").val(subscriptionId);
    // $("input.subscriptionId").attr("id", "subscription_id_" + productId);
    // $("input.subscriptionId").attr("value", subscriptionId);

    // update UI
    $('.single-option-selector:eq(0)').val(productTitle)[0].dispatchEvent(new Event("change"));
    $('.single-option-selector:eq(0)').trigger("change");


    $(this).addClass("active");
    $(this).html("Selected!");
    currentStep = 3;
    _this.onUpdate();
    _this.scrollTo($("[data-scrollid=select-quantity]"), 300);
  });

  $("[data-action=selectQuantity]").click(function(ev) {
    ev.preventDefault();
    // first deselect old ones
    var old = $("[data-action=selectQuantity].active");
    if (old) {
      $(old).removeClass("active");
      $(old).html("Select");
    }
    // store data
    quantity = $(this).data("title");
    quantityHuman = $(this).data("human");
    // $("input[name=quantity]").val(quantity);
    // update UI
    $(this).addClass("active");
    $(this).html("Selected!");

    $('.single-option-selector:eq(1)').val(quantity)[0].dispatchEvent(new Event("change"));
    $('.single-option-selector:eq(1)').trigger("change");

    currentStep = 4;
    _this.onUpdate();
    _this.scrollTo($("[data-scrollid=select-frequency]"), 300);
  });

  $("[data-action=selectFrequency]").click(function(ev) {
    ev.preventDefault();
    // first deselect old ones
    var old = $("[data-action=selectFrequency].active");
    if (old) {
      $(old).removeClass("active");
      $(old).html("Select");
    }
    // store data
    frequency = $(this).data("value");
    frequencyHuman = $(this).data("human");
    $("input[name='properties[shipping_interval_frequency]']").val(frequency);
    $("select[name='properties[shipping_interval_frequency]']").val(frequency);
    // update UI
    $(this).addClass("active");
    $(this).html("Selected!");
    _this.onUpdate();
    _this.scrollTo($("[data-scrollid=select-grind]"), 300);
  });

  // Grind options
  $("select[name='selectGrind']").on('change', function(ev) {
    ev.preventDefault();

    // store data
    grind = $(this).val();
    var selectedOption = $('option:selected', this);
    grindHuman = $(selectedOption).data("human");

    $("select[name='properties[Grind]']").val(grind);

    // update UI
    $(this).addClass("active");
    _this.onUpdate();
    _this.scrollTo($("[data-scrollid=confirmation]"), 300);
  });

  $(".add-to-cart").click(function(ev) {
    ev.preventDefault();

    $(".product-form:eq(0)").submit();
  })
});

onUpdate = function() {

  // update price
  // $(".price").html("$" + (parseFloat(price / 100).toFixed(2)));
  setTimeout(function() {
    price = $('[data-regular-price]:eq(0)').html();
    // console.log(price);

    $(".confirmation__price").html(price);

  }, 500);

  // rebuild natural langauge
  var productAnchor = `<a class='underline' data-action='scrollto' data-scrollid='section[data-scrollid=select-product]'>${productTitle}</a>`;
  var frequencyAnchor = `<a class='underline' data-action='scrollto' data-scrollid='section[data-scrollid=select-frequency]'>${frequencyHuman}</a>`;
  var quantityAnchor = `<a class='underline' data-action='scrollto' data-scrollid='section[data-scrollid=select-quantity]'>${quantityHuman}</a>`;
  var grindAnchor = `<a class='underline' data-action='scrollto' data-scrollid='section[data-scrollid=select-grind]'>${grindHuman}</a>`;
  var output = `You will receive ${quantityAnchor} of ${productAnchor} ${grindAnchor} ${frequencyAnchor}.`;
  $(".natural-language").html(output);


  // hook up newly-constructed anchors in nautral language to scroll when clicked
  _this.connectNewScrollComponents();
  // update the status bar
  if (productTitle) $($(".statusbar div")[1]).addClass("active");
  if (quantity) $($(".statusbar div")[2]).addClass("active");
  if (frequency) $($(".statusbar div")[3]).addClass("active");
  if (grind) $($(".statusbar div")[4]).addClass("active");
  // show sections
  if (productTitle) $($("section[data-scrollid='select-quantity']")).removeClass("hide");
  if (quantity) $($("section[data-scrollid='select-frequency']")).removeClass("hide");
  if (frequency) $($("section[data-scrollid='select-grind']")).removeClass("hide");
  if (grind) $($("section[data-scrollid='confirmation']")).removeClass("hide");
}

connectNewScrollComponents = function() {
  $(".natural-language [data-scrollid]").on("click", function(ev) {
    ev.preventDefault();
    var scrollId = $(this).data('scrollid');
    var el = $(scrollId);
    _this.scrollTo(el, 0);
  });
}

scrollTo = function(el, delay) {
  if (el) {
    setTimeout(function() {
      var isMobile = $(window).width() < 768;
      $('html, body').animate({
          scrollTop: $(el).offset().top - (isMobile ? 20 : 90)
      }, 500);
    }, delay);
  }
}

// status bar should appear when page is scrolled down
// Based on https://www.html5rocks.com/en/tutorials/speed/animations/#debouncing-scroll-events
var ticking = false;
function update() {
  // reset the tick so we can
  // capture the next onScroll
  ticking = false;
}
function onScroll() {
  requestTick();
  var y = window.scrollY;
  if ($("section[data-scrollid='select-product']").length > 0) {
    var productSectionTop = $("section[data-scrollid='select-product']").offset().top;
    if (scrollY > productSectionTop) {
      $(".statusbar").addClass("active");
    } else {
      $(".statusbar").removeClass("active");
    }
  }
}
function requestTick() {
  if(!ticking) {
    requestAnimationFrame(update);
  }
  ticking = true;
}
window.addEventListener('scroll', onScroll, false);

